module.exports = __webpack_public_path__ + "img/noBG.39d97307.png";